module.exports = __webpack_public_path__ + "static/media/Details_Selected.c4d2c6c3.svg";